import { getAzAccount, type AzAccountInfo } from "./auth.js";
import { readFoundryConfig, readSeedEndpoint, type FoundryConfig } from "./foundry-config.js";
import { readConfig, type CliConfig } from "./config.js";
import { getAzdFollowsAz } from "./azd.js";

export interface LocalContext {
  az: AzAccountInfo | null;
  foundry: FoundryConfig | null;
  seedEndpoint: string | null;
  gatewayCache: CliConfig | null;
  azdFollowsAz: boolean;
  tenantAligned: boolean;
}

/** Gather the full local m8t picture. Never throws on a missing/unauthenticated
 *  piece — each absent surface becomes null/false. */
export async function resolveLocalContext(): Promise<LocalContext> {
  const az = await getAzAccount().catch(() => null);
  const foundry = await readFoundryConfig();
  const seedEndpoint = await readSeedEndpoint();
  const gatewayCache = await readConfig();
  const azdFollowsAz = await getAzdFollowsAz();
  const tenantAligned = az !== null && foundry !== null && az.tenantId === foundry.tenantId;
  return { az, foundry, seedEndpoint, gatewayCache, azdFollowsAz, tenantAligned };
}
